var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.161 9.758v.484c0 .266-.217.484-.484.484h-3.951v3.951c0 .267-.218.484-.484.484h-.484c-.266 0-.484-.217-.484-.484v-3.951h-3.951c-.267 0-.484-.218-.484-.484v-.484c0-.266.217-.484.484-.484h3.951v-3.951c0-.267.218-.484.484-.484h.484c.266 0 .484.217.484.484v3.951h3.951c.267 0 .484.218.484.484zm4.839.242c0 5.524-4.476 10-10 10s-10-4.476-10-10 4.476-10 10-10 10 4.476 10 10zm-1.29 0c0-4.835-3.924-8.71-8.71-8.71-4.835 0-8.71 3.924-8.71 8.71 0 4.835 3.924 8.71 8.71 8.71 4.835 0 8.71-3.924 8.71-8.71z",
    fill: "#858586",
    transform: "matrix(.70710678 .70710678 -.70710678 .70710678 9.999645 -4.142162)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnClose);
export default __webpack_public_path__ + "static/media/icn_close.0b13068a9511b69f7dd178ec9f6fe678.svg";
export { ForwardRef as ReactComponent };